<template>
  <div v-if="this.isSuper()">
    <el-button icon="fa fa-trash-alt"
     @click="deleteEntry()" size="small" type="danger" circle>
   </el-button>
    </div>
  </template>

  <script>
  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],
    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'structtable'
      }
    },
    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, this.rowData.site_id ? '/site-struct' : '/struct', this.rowData.category +
         ' / ' + this.rowData.type +
          (this.rowData.subType ? '/ ' + this.rowData.subType : '') +
           ' ' + (this.rowData.name ? ' / ' + this.rowData.name : ''),
           this.onDelete)
      },

      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
